var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 17.7188H17.0625V3.28125C17.0625 2.93315 16.9242 2.59931 16.6781 2.35317C16.4319 2.10703 16.0981 1.96875 15.75 1.96875H5.25C4.9019 1.96875 4.56806 2.10703 4.32192 2.35317C4.07578 2.59931 3.9375 2.93315 3.9375 3.28125V17.7188H1.96875C1.7947 17.7188 1.62778 17.7879 1.50471 17.911C1.38164 18.034 1.3125 18.201 1.3125 18.375C1.3125 18.549 1.38164 18.716 1.50471 18.839C1.62778 18.9621 1.7947 19.0312 1.96875 19.0312H19.0312C19.2053 19.0312 19.3722 18.9621 19.4953 18.839C19.6184 18.716 19.6875 18.549 19.6875 18.375C19.6875 18.201 19.6184 18.034 19.4953 17.911C19.3722 17.7879 19.2053 17.7188 19.0312 17.7188ZM5.25 3.28125H15.75V17.7188H5.25V3.28125ZM13.7812 10.8281C13.7812 11.0228 13.7235 11.2131 13.6154 11.375C13.5072 11.5369 13.3534 11.6631 13.1736 11.7376C12.9937 11.8121 12.7958 11.8316 12.6048 11.7936C12.4139 11.7556 12.2385 11.6618 12.1008 11.5242C11.9632 11.3865 11.8694 11.2111 11.8314 11.0202C11.7934 10.8292 11.8129 10.6313 11.8874 10.4514C11.9619 10.2716 12.0881 10.1178 12.25 10.0096C12.4119 9.90148 12.6022 9.84375 12.7969 9.84375C13.0579 9.84375 13.3083 9.94746 13.4929 10.1321C13.6775 10.3167 13.7812 10.5671 13.7812 10.8281Z",
    fill: "#BE202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorIcon);
export default __webpack_public_path__ + "static/media/doorIcon.477c931a9420db8973c6fe866eb12521.svg";
export { ForwardRef as ReactComponent };